import * as core from '../../../../../../../core'

import { query } from './ideas-report-card.query'

export const RESOURCE = {
  payload: {
    alias: 'ideas.report.card',
    description:
      'Report Card showing key metrics related to Innovation performance',
    name: 'Ideas Report Card',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
